import { TruckIcon } from '@heroicons/react/outline';
import { createBaseColumn } from '../../utils/columnUtils';
import { TableTemplate } from '../../types';

export const collectShippingTemplate: TableTemplate = {
  id: 'collect_shipping',
  name: 'Collect Shipping Info',
  description: 'Request and collect shipping addresses from creators for product seeding',
  icon: TruckIcon,
  iconName: 'TruckIcon',
  variant: 'gradient',
  defaultConfig: {
    columns: [
      createBaseColumn('first_name', 'First Name', {
        cell_type: 'communication',
        prompt: 'Extract ONLY the creator\'s first name (given name) from their shipping information in the email thread. Look for where they explicitly provided shipping details. If they write "John Smith", return only "John". Return only the first name, nothing else.',
        data_type: 'text',
        requires_thread: true,
        communication_sources: ['email_history', 'outlook_conversations'],
        email_provider: 'outlook'
      }),
      createBaseColumn('last_name', 'Last Name', {
        cell_type: 'communication',
        prompt: 'Extract ONLY the creator\'s last name (surname/family name) from their shipping information in the email thread. Look for where they explicitly provided shipping details. If they write "John Smith", return only "Smith". Return only the last name, nothing else.',
        data_type: 'text',
        requires_thread: true,
        communication_sources: ['email_history', 'outlook_conversations'],
        email_provider: 'outlook'
      }),
      createBaseColumn('street_address', 'Street Address', {
        cell_type: 'communication',
        prompt: 'Extract ONLY the street address (street name and number) from where the creator explicitly provided their shipping address. Include apartment/unit numbers if provided. Do NOT include city, postal code, or country. Return exactly as written by the creator.',
        data_type: 'text',
        requires_thread: true,
        communication_sources: ['email_history', 'outlook_conversations'],
        email_provider: 'outlook'
      }),
      createBaseColumn('postal_code', 'Postal Code', {
        cell_type: 'communication',
        prompt: 'Extract ONLY the postal code or zip code from where the creator explicitly provided their shipping address. Return exactly as written (with spaces/dashes if included). Do not include city or country.',
        data_type: 'text',
        requires_thread: true,
        communication_sources: ['email_history', 'outlook_conversations'],
        email_provider: 'outlook'
      }),
      createBaseColumn('city', 'City', {
        cell_type: 'communication',
        prompt: 'Extract or infer the city name from the creator\'s shipping address. First, look for explicitly stated city. If not explicitly stated, infer from postal code if possible (e.g., "114 52" → "Stockholm", "10001" → "New York"). Return only the city name.',
        data_type: 'text',
        requires_thread: true,
        communication_sources: ['email_history', 'outlook_conversations'],
        email_provider: 'outlook'
      }),
      createBaseColumn('state', 'State/Region', {
        cell_type: 'communication',
        prompt: 'Extract or infer the state/region/province if applicable (mainly for US, Canada, Australia). First, look for explicitly stated state. If not stated, infer from city or postal code if possible (e.g., "New York" → "NY", "Los Angeles" → "CA"). Leave empty if not applicable or cannot be determined.',
        data_type: 'text',
        requires_thread: true,
        communication_sources: ['email_history', 'outlook_conversations'],
        email_provider: 'outlook'
      }),
      createBaseColumn('country', 'Country', {
        cell_type: 'communication',
        prompt: 'Extract or infer the country name from the creator\'s shipping address. First, look for explicitly stated country. If not stated, infer from postal code format or city (e.g., "114 52" → "Sweden", "10001" → "United States", "Stockholm" → "Sweden"). Return full country name (e.g., "Sweden", "United States", "United Kingdom").',
        data_type: 'text',
        requires_thread: true,
        communication_sources: ['email_history', 'outlook_conversations'],
        email_provider: 'outlook'
      }),
      createBaseColumn('phone_number', 'Phone Number', {
        cell_type: 'communication',
        prompt: 'Extract ONLY the phone number from where the creator explicitly provided their shipping information. Include country code if provided (e.g., +46, +1). Return exactly as written by the creator with all spaces, dashes, or parentheses.',
        data_type: 'text',
        requires_thread: true,
        communication_sources: ['email_history', 'outlook_conversations'],
        email_provider: 'outlook'
      })
    ]
  }
};

